export default __webpack_public_path__ + "static/VERONICA-ORTEGA-NATURALEZA-DE-VIDA-BY-VOS.GRAFICA-f40ef4ae9436c8b161be82c50095fdaf.png";